import React from "react";
import MaterialIcon from "../../components/BuilderComponents/MaterialIcon";

const Pagination = ({ pageTrack, pagination, onPageChange, onLimitChange }) => {
  // State for limit (records per page) and current page

  // Handler for changing limit
  const handleLimitChange = (event) => {
    const newLimit = Number(event.target.value);
    if (onLimitChange) {
      onLimitChange(newLimit); // Call the prop function to make an API call
    }
  };

  // Handlers for pagination buttons
  const goToPreviousPage = () => {
    if (pagination.page > 1) {
      const newPage = pagination.page - 1;
      onPageChange(newPage);
    }
  };

  const goToNextPage = () => {
    const newPage = pagination.page + 1;
    onPageChange(newPage);
  };

  return (
    <div className="d_flex text_wrap_nowrap align_center justify_end w_fit ml_auto">
      <select className="builder_input mr_3" value={pagination.limit} onChange={handleLimitChange}>
        <option value="10">10</option>
        <option value="20">20</option>
        <option value="30">30</option>
        <option value="40">40</option>
        <option value="50">50</option>
      </select>

      <MaterialIcon
        name="chevron_left"
        className={`chevron mr_2 ${pageTrack.currPage === 1 ? "chevron_disabled" : ""}`}
        onClick={pageTrack.currPage > 1 ? goToPreviousPage : null}
      />

      <span className="mr_2">
        Page {pageTrack.currPage} of {pageTrack.totalPages}
      </span>

      <MaterialIcon
        name="chevron_right"
        className={`chevron ${pageTrack.currPage === pageTrack.totalPages ? "chevron_disabled" : ""}`}
        onClick={pageTrack.currPage < pageTrack.totalPages ? goToNextPage : null}
      />
    </div>
  );
};

export default Pagination;
